export default __webpack_public_path__ + "static/media/pep.0688f73e.png";